import React from 'react';
import { Outlet } from 'react-router-dom';

/** Role checks run in protectedRouteLoader; this wrapper keeps the route tree shape. */
const RoleGuard: React.FC = () => <Outlet />;

export default RoleGuard;
